import React from 'react'
import BlockCards from '@berlitz/blocks/lib/BlockCards'
import { getSerializedHTML, getBackgroundColor, findSpansAndLinks, getTextHightlightBackgroundColor, wrapParagraph } from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'

const ModularBlockCards = ({ primary, items, backgroundColor, pageLinks }) => {
const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
const processedParagraphsCards = findSpansAndLinks(primary.cards_subtitle?.raw, pageLinks);

  return (
    <SliceWrapper
      backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}
    >
      <BlockCards
        title={primary.cards_title}
        subtitle={processedParagraphsCards.map(p => p.text).join('')} 
        cards={items.map(item => {
          const highlight = getTextHightlightBackgroundColor(item?.title_highlight)
          const processedParagraphsCardItem = findSpansAndLinks(item?.card_content?.raw, pageLinks);
          return {
            imageSrc: item.card_image.url,
            text: item?.card_title,
            subtitle: wrapParagraph(processedParagraphsCardItem.map(p => p.text).join('')),
            highlight: highlight,
            ctaText: item.card_button_text,
            url: item?.one_page_link || item?.card_link.url,
            idAttr:  highlight === 'primary' ? 'notHighlighted' : 'isHighlighted'
          }
        })}
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        url
      />
    </SliceWrapper>
  )
}

export default ModularBlockCards
